// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --site-fonts: "Helvetica Neue", Helvetica, Arial, sans-serif;
  --mono-fonts: Menlo, Monaco, Consolas, "Courier New", monospace;
  --blue-highlight: hsl(193, 81%, 41%);
  --body-bg: hsl(0, 0%, 96%);
  --grey-bg: hsl(0, 0%, 24%);
  --grey-highlight: hsl(0, 0%, 75%);
  --full-black: hsl(0, 0%, 0%);
  --full-red: hsl(0, 100%, 50%);
  --full-brown: hsl(0, 51%, 33%);
  --full-orange: hsl(39, 100%, 50%);
  --full-yellow: hsl(60, 100%, 50%);
  --full-green: hsl(120, 100%, 25%);
  --full-darkgreen: hsl(120, 100%, 13%);
  --full-limegreen: hsl(120, 61%, 50%);
  --full-white: hsl(250, 100%, 100%);
  --datablock-bg: hsla(0, 0%, 100%, 0.2);
  --datablock-border: hsla(0, 0%, 0%, 0.3);
  --transparent: hsla(0, 0%, 0%, 0);
  --light-wight: hsl(0, 0%, 93%);
  --creamy-white: hsl(0, 0%, 80%);
  --pale-white: hsl(0, 0%, 73%);
  --mostly-transparent: hsla(0, 0%, 0%, 0.2);
  --decor-banner-green: hsl(149, 29%, 56%);
  --nav-text-shadow: hsl(0, 0%, 5%);
  --egg-white: hsl(0, 0%, 80%);
  --tabs-grey-shadow: hsl(0, 0%, 58%);
  --jbox-shadow: hsla(0, 0%, 0%, 0.25);
  --mapbackground: hsl(0, 0%, 60%);
}

/*div * {
  scrollbar-width: none; /* Firefox
  -ms-overflow-style: none; /* IE 10+
}
div *::-webkit-scrollbar-track {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: transparent;
}
div *::-webkit-scrollbar {
  width: 3px !important;
  background-color: transparent;
}
div *::-webkit-scrollbar-thumb {
  background-color: transparent;
}

.on-scrollbar{
  scrollbar-width: thin; /* Firefox
  -ms-overflow-style: none; /* IE 10+
}

.on-scrollbar::-webkit-scrollbar-track {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

.on-scrollbar::-webkit-scrollbar {
  width: 6px !important;
  background-color: transparent;
}

.on-scrollbar::-webkit-scrollbar-thumb {
  background-color: #acacac;
}*/

table {
  border: 1px solid var(--full-black);
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  background-color: var(--full-white);
}

thead {
  border: 1px solid var(--full-black);
}

th {
  padding-left: 5px;
}

#main_block h3 {
  margin-top: 0;
}

table.search {
  border: 1px solid var(--full-black);
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  background-color: transparent;
  vertical-align: middle;
}

table.message {
  border: none;
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  background-color: var(--full-white);
  vertical-align: top;
}

.text_top {
  vertical-align: top;
}

.align_right {
  float: right;
}

textarea {
  width: 95%;
}

img {
  max-width: 100%;
}

.boxed {
  background-color: var(--full-white);
  box-sizing: border-box;
  display: inline-block;
  padding-top: 8px;
  padding-bottom: 6px;
  padding-right: 10px;
  padding-left: 10px;
  width: 45px;
  text-align: center;
  color: var(--full-black);
  margin-bottom: -1px;
  border-left: 1px solid var(--full-black);
  border-right: 1px solid var(--full-black);
  border-top: 1px solid var(--full-black);
  border-bottom: 1px solid var(--full-black);
  font-weight: bold;
}

.boxed_right_arrow {
  margin-left: -1px;
}

.small_img {
  height: 14px;
  vertical-align: middle;
  padding-bottom: 3px;
}

.monofont {
  font-family: var(--mono-fonts);
}

.red,
.red_body {
  color: var(--full-red);
}

span.red_important strong {
  color: var(--full-red) !important;
}

.orange {
  color: var(--full-orange);
}

.green {
  color: var(--full-limegreen);
}

@media not all and (pointer: coarse) {
  .red:hover {
    color: var(--full-white);
  }
}

.footer strong {
  color: var(--blue-highlight);
}

.sidebar_link {
  color: var(--blue-highlight);
}

@media not all and (pointer: coarse) {
  .sidebar_link:hover {
    color: var(--full-white);
  }
}

ol {
  list-style-type: circle;
  margin-left: 0;
  padding-left: 1em;
  margin-left: 1em;
}

ol > li {
  width: 100%;
  margin-left: 0;
  padding-left: 0;
}

td {
  padding: 7px;
}

hr {
  display: block;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  margin-left: auto;
  margin-right: auto;
  border-style: inset;
  border-top: 0.1em solid var(--grey-bg);
  color: var(--body-bg);
}

body {
  height: 100vh;
  width: 100vw;
  background-color: var(--body-bg);
  padding-left: 20px;
  padding-right: 20px;
  min-width: 400px;
  margin-left: auto;
  margin-right: auto;
  font-family: var(--site-fonts);
  font-size: 14px;
  line-height: 1.42857143;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
}

body::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}

.container {
  margin: 30px auto;
  width: 100%;
  position: relative;
  width: 100%;
  margin-top: 0;
  padding-left: 5px;
  padding-right: 5px;
}

div#content.container {
  position: fixed;
  top: 105px;
  padding-left: 20px;
  padding-right: 20px;
  width: calc(100vw - 40px);
  margin-bottom: 40px;
  overflow: scroll;
  height: calc(100vh - 125px);
}

div#main_block.row {
  margin-left: 0;
  padding-top: 5px;
}

div#header {
  margin: 0;
  width: calc(100vw - 40px);
  position: fixed;
}

div#links.row {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  top: 0;
}

div#num_results.row {
  position: relative;
  width: 100%;
  height: inherit;
  padding-top: 10px;
  margin-right: 0;
  margin-left: 0;
  margin-bottom: 0;
}

table.search thead {
  border: 0;
}

div#log.left {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  padding-right: 0;
  padding-left: 0;
}

.acarshub-message-group {
  margin: auto;
}

#size {
  color: var(--blue-highlight);
}

#database {
  color: var(--blue-highlight);
}

#log {
  margin-right: 5px;
}

.search_label {
  width: 30%;
  vertical-align: middle;
  color: var(--blue-highlight);
}

.search_term {
  width: 70%;
  padding-left: 15px;
  padding-right: 20px;
}

.fixed_results {
  position: fixed;
  top: 60px;
  bottom: 30px;
  padding-top: 0;
  margin-bottom: 10px;
  width: 280px;
  margin-right: 5px;
  margin-left: 10px;
  padding-right: 5px;
  padding-top: 10px;
  overflow-y: auto;
  overflow-x: hidden;
}

.fixed_menu {
  position: fixed;
  top: 170px;
  bottom: 30px;
  padding-top: 0;
  margin-bottom: 10px;
  width: 280px;
  margin-top: 0;
  margin-right: 5px;
  margin-left: 10px;
  margin-bottom: 30px;
  padding-right: 5px;
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.fixed_menu_short {
  position: fixed;
  top: 150px;
  bottom: 30px;
  padding-top: 0;
  margin-bottom: 10px;
  width: 280px;
  margin-top: 0;
  margin-right: 5px;
  margin-left: 10px;
  margin-bottom: 30px;
  padding-right: 5px;
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.spread_text {
  letter-spacing: 1px;
  padding-left: 4px;
}

@media not all and (pointer: coarse) {
  a.spread_text:hover {
    color: var(--full-black);
  }
}

.red {
  color: var(--full-red);
}

.white {
  color: var(--full-white);
}
select {
  min-width: 100%;
}

input {
  min-width: 100%;
  width: 30px;
  color: var(--full-black);
}

label {
  padding-top: 5px;
}

.menu_non_link {
  color: var(--blue-highlight);
  text-transform: uppercase;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: var(--grey-bg);
  text-align: left;
  border: 1px solid var(--full-black);
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  z-index: 20;
  font-weight: bold;
}

@media not all and (pointer: coarse) {
  .footer a:hover {
    color: var(--full-white);
    transition: all 0.25s ease-out;
  }
}

.footer div {
  display: inline-block;
  border-right: 1px solid var(--grey-highlight);
  padding-right: 5px;
}

.shadow {
  box-shadow: 2px 2px 2px 1px var(--mostly-transparent);
}

pre {
  box-shadow: 2px 2px 2px 1px var(--mostly-transparent);
  white-space: pre-wrap; /* Since CSS 2.1 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
  display: block;
  padding: 9.5px;
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.42857143;
  color: #333;
  word-break: break-all;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
}

a {
  color: var(--blue-highlight);
  text-decoration: none;
  text-transform: uppercase;
  text-decoration: none;
}

@media not all and (pointer: coarse) {
  a:hover {
    color: var(--full-black);
    text-decoration: none;
  }
}

a:active {
  color: var(--blue-highlight);
  text-decoration: none;
}

a:visited {
  color: var(--blue-highlight);
  text-decoration: none;
}

.wrap {
  display: block;
  position: relative;
  -webkit-box-shadow: 0 0 70px var(--full-white);
  -moz-box-shadow: 0 0 70px var(--full-white);
  box-shadow: 0 0 70px var(--full-white);
  margin-left: auto;
  margin-right: auto;
  top: 0;
}

.decor {
  background: var(--decor-banner-green);
  background: -webkit-linear-gradient(
    left,
    var(--grey-bg) 50%,
    var(--blue-highlight) 50%
  );
  background: -moz-linear-gradient(
    left,
    var(--grey-bg) 50%,
    var(--blue-highlight) 50%
  );
  background: -o-linear-gradient(
    left,
    var(--grey-bg) 50%,
    var(--blue-highlight) 50%
  );
  background: linear-gradient(
    to left,
    var(--grey-bg) 50%,
    var(--blue-highlight) 50%
  );
  background-size: 50px 25%;
  padding: 2px;
  display: block;
  z-index: 200;
}

ul {
  list-style: none;
  position: relative;
  text-align: left;
  padding-left: 10px;
}

.right_side {
  float: right;
  z-index: 300;
}

li {
  float: left;
}

/* clear'n floats */
ul::after {
  clear: both;
}

ul::before,
ul::after {
  content: " ";
  display: table;
}

nav {
  position: relative;
  background: var(--grey-bg);
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 1px 1px 1px var(--nav-text-shadow);
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  z-index: 10;
  padding-bottom: 1px;
}

.nav_text {
  display: block;
  padding-top: 23px;
  padding-bottom: 10px;
  padding-right: 20px;
  padding-left: 20px;
  color: var(--blue-highlight);
  text-transform: uppercase;
}

ul.primary li a.invert_a,
ul.primary li a.invert_a:visited {
  color: var(--full-white) !important;
}

/* prime */
ul.primary li a,
ul.primary li a:visited {
  display: block;
  padding-top: 35px;
  padding-bottom: 10px;
  padding-right: 20px;
  padding-left: 20px;
}

ul.primary li:last-child a {
  border-right: none;
}

@media not all and (pointer: coarse) {
  ul.primary li a.invert_a:hover {
    color: var(--blue-highlight) !important;
    transition: all 0.25s ease-in;
  }
  ul.primary li a:hover,
  ul.primary li a:active {
    color: var(--full-white);
    transition: all 0.25s ease-in;
  }
}

/* subs */
ul.sub {
  position: absolute;
  z-index: 200;
  box-shadow: 2px 2px 0 var(--grey-highlight);
  width: 35%;
  display: none;
}

ul.sub li {
  float: none;
  margin: 0;
}

ul.sub li a {
  border-bottom: 1px dotted var(--creamy-white);
  border-right: none;
  color: var(--full-black);
  padding: 15px 0;
}

ul.sub li:last-child a {
  border-bottom: none;
}

ul.sub li a:hover {
  color: var(--full-white);
  background: var(--light-white);
}

/* sub display */
ul.primary li:hover ul {
  display: block;
}

/* keeps the tab background white */
ul.primary li:hover a {
  color: var(--full-white);
  text-shadow: none;
}

ul.primary li:hover > a {
  color: var(--full-white);
}

/* Collapse */

input[type="checkbox"] {
  display: none;
}

.wrap-collabsible {
  padding-top: 0;
}

.lbl-toggle {
  display: block;
  text-transform: uppercase;
  text-align: left;
  color: var(--blue-highlight);
  background: transparent;
  cursor: pointer;
  transition: all 0.25s ease-out;
  font-weight: normal;
  padding-top: 10px;
}

.lbl-toggle:hover {
  color: var(--full-white);
}

.lbl-toggle::before {
  content: " ";
  display: inline-block;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid currentColor;
  vertical-align: middle;
  margin-right: 0.7rem;
  transform: translateY(-2px);
  transition: transform 0.2s ease-out;
}

.toggle::checked + .lbl-toggle::before {
  transform: rotate(90deg) translateX(-3px);
}

.collapsible-content {
  max-height: 0;
  overflow: scroll;
  height: calc(100% - 250px);
  transition: max-height 0.25s ease-in-out;
}

.toggle:checked + .lbl-toggle + .collapsible-content {
  max-height: 100%;
}

.toggle::checked + .lbl-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.collapsible-content .content-inner {
  background: transparent;
  color: var(--blue-highlight);
  padding-right: 10px;
  padding-left: 10px;
  overflow: scroll;
}

.collapsible-content p {
  margin-bottom: 30px;
}

/* message tabs */

.tabinator {
  background: transparent;
}

.tabinator input {
  display: none;
}

.tabinator label {
  background-color: var(--full-white);
  box-sizing: border-box;
  display: inline-block;
  padding-top: 8px;
  padding-bottom: 6px;
  padding-right: 10px;
  padding-left: 10px;
  width: 90px;
  text-align: center;
  color: var(--full-black);
  margin-top: 0px;
  margin-bottom: -1px;
  margin-left: -1px;
  font-weight: bold;
  border-left: 1px solid var(--full-black);
  border-top: 1px solid var(--full-black);
  border-right: 1px solid var(--full-black);
  border-bottom: 1px solid var(--full-black);
}

.tabinator label::before {
  content: "";
  display: block;
  width: 100%;
  height: 15px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
}

.tabinator label:hover {
  color: var(--grey-bg);
  cursor: pointer;
}

.tabinator input:checked + label {
  position: relative;
  color: var(--full-white);
  background: var(--full-black);
  border-left: 1px solid var(--full-black);
  border-top: 1px solid var(--full-black);
  border-right: 1px solid var(--full-black);
  font-weight: bold;
  font-style: normal;
}

.tabinator input::checked + label::after {
  display: block;
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  box-shadow: 0 0 15px var(--tabs-grey-shadow);
}

[id^="message"] {
  display: none;
  border-top: 1px solid var(--grey-highlight);
}

.checked {
  display: block;
  box-shadow: 0 0 15px var(--grey-highlight);
}

.circle_red {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  border: 1px solid;
  background-color: var(--full-red);
  display: inline-block;
}

.circle_orange {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  border: 1px solid;
  background-color: var(--full-orange);
  display: inline-block;
}

.circle_yellow {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  border: 1px solid;
  background-color: var(--full-yellow);
  display: inline-block;
}

.circle_green {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  border: 1px solid;
  background-color: var(--full-green);
  display: inline-block;
}

img.banner_img {
  max-width: 70px;
  max-height: 70px;
}

li.img_box {
  width: 100px;
  height: 82px;
  display: block;
  padding-top: 5px;
  padding-bottom: 0;
  border-right: 1px solid var(--grey-bg);
  text-align: center;
  color: var(--grey-bg);
  text-shadow: none;
}

li.img_box svg {
  max-width: 85%;
  max-height: 80px;
  letter-spacing: 0;
}

/* canvas {
  width: 100% !important;
  height: 100% !important;
} */

/* .canvas_wrapper {
  position: relative;
  width: 100%;
  max-width: 1000px !important;
  display: flex;
  /* float: left;
} */

.chart-container {
  position: relative;
  /* min-height: auto; */
  width: 100%;
  max-width: 1000px !important;
  height: 300px;
  /* overflow: hidden; */
}

#chart_msg_good,
#chart_msg_empty {
  height: 150px !important;
}

/* modal window stuff */

#set_modal.jBox-wrapper .jBox-title {
  background-color: var(--egg-white);
  color: var(--blue-highlight);
  font-family: var(--site-fonts);
  font-size: 20px;
  text-transform: uppercase;
  text-align: center;
}

#set_modal.jBox-wrapper .jBox-content {
  background-color: var(--grey-bg);
  font-family: var(--site-fonts);
}

#airplane .jBox-content {
  font-family: var(--mono-fonts) !important;
  text-transform: uppercase;
}

#airplane.jBox-Tooltip.jBox-wrapper .jBox-content {
  border-radius: 0 0 15px 15px;
  -moz-border-radius: 0 0 15px 15px;
}

.jBox-wrapper {
  border-radius: 15px;
  border: 2px solid var(--datablock-border);
  padding: 5px;
  border-radius: 15px;
  -moz-border-radius: 15px;
  background-color: var(--grey-bg);
  box-shadow: 0 0 3px var(--jbox-shadow);
}

.jBox-Modal {
  max-height: 80%;
}

.jBox-wrapper.jBox-Tooltip,
.jBox-wrapper.jBox-Mouse {
  max-width: 250px;
}

.jBox-container {
  background-color: var(--grey-bg);
  border-radius: 0;
  box-shadow: 0 0 0 var(--transparent) !important;
  width: inherit;
  height: inherit;
}

.jBox-Mouse.jBox-wrapper .jBox-content,
.jBox-Tooltip.jBox-wrapper .jBox-content {
  background-color: var(--grey-bg);
  color: var(--blue-highlight);
  font-size: 12px;
  font-weight: bold;
  font-family: var(--site-fonts);
  box-shadow: none;
}

.jBox-wrapper .jBox-title {
  background-color: var(--egg-white);
  color: var(--blue-highlight);
  font-family: var(--site-fonts);
  font-size: 15px;
  text-transform: uppercase;
  text-align: center;
  border-radius: 15px 15px 0 0;
  -moz-border-radius: 15px 15px 0 0;
  text-transform: uppercase;
  padding: 0;
  width: 100%;
}

a[x-apple-data-detectors] {
  color: inherit !important;
  text-decoration: none !important;
  font-size: inherit !important;
  font-family: inherit !important;
  font-weight: inherit !important;
  line-height: inherit !important;
}

@media only screen and (min-width: 0px) {
  .container {
    min-width: 400px;
    max-width: calc(100vw - 40px);
  }
}

@media screen and (max-width: 1070px) {
  #release_version {
    display: none;
  }
}

@media screen and (max-width: 1150px) {
  #discord_badge {
    display: none;
  }
}

@media only screen and (max-width: 1200px) {
  div#content.container {
    top: 77px;
    height: calc(100vh - 98px);
  }

  #logo_image {
    display: none;
  }

  ul.primary li a {
    padding-top: 23px;
  }

  nav {
    letter-spacing: 1px;
  }

  .right_side {
    float: left;
  }

  #planes {
    max-height: calc(100vh - 130px) !important;
  }

  #mapid {
    height: calc(100vh - 130px) !important;
    max-height: calc(100vh - 130px) !important;
  }

  #update_notice {
    display: none;
  }
}

@media only screen and (max-width: 970px) {
  #search_results {
    width: calc(100vw - 295px) !important;
  }

  #side_pane {
    width: 200px !important;
  }

  div#content.container {
    top: 140px;
    height: calc(100vh - 160px);
  }

  .decor {
    padding: 3px;
  }

  .wrap {
    width: 100%;
    margin-top: 0;
    font-size: 10px;
  }

  li {
    float: none;
  }

  ul.primary li a {
    padding-top: 2.5px;
    padding-bottom: 2.5px;
    padding-right: 2.5px;
    padding-left: 2.5px;
  }

  ul.sub li a:hover {
    color: var(--egg-white);
    background: none;
  }

  #discord_badge,
  #github_link,
  #release_version,
  .dont_show,
  .show_when_big {
    display: none;
  }

  #msg_body {
    column-span: all;
  }

  /* .show_when_small {
    display: inline-block;
  } */

  #planes {
    max-height: calc(100vh - 170px) !important;
  }

  #mapid {
    height: calc(100vh - 170px) !important;
    max-height: calc(100vh - 170px) !important;
  }
}

@media only screen and (min-width: 970px) {
  .show_when_small {
    display: none;
  }
}

@media only screen and (max-width: 700px) {
  #mapid {
    width: 100%;
    max-width: 100% !important;
  }

  #planes {
    display: none !important;
  }

  div#content.container {
    top: 140px;
    height: calc(100vh - 160px);
  }

  #search_results {
    width: 100% !important;
  }

  #side_pane {
    width: 100% !important;
  }

  #acarshub_help {
    display: none;
  }
}

#msg_body {
  column-span: inherit;
}

.show_strong {
  font-weight: bold;
  font-family: var(--mono-fonts);
}

#search_results {
  width: calc(100vw - 440px);
  max-height: 100%;
  margin-left: 5px;
  overflow: auto;
  float: left;
}

#side_pane {
  width: 340px;
  max-height: 100%;
  overflow: auto;
  float: left;
}

#mapid {
  height: calc(100vh - 160px);
  max-height: calc(100vh - 160px);
  width: 100%;
  background-color: var(--mapbackground);
  float: left;
  max-width: calc(100vw - 435px);
  flex: 1 1 auto;
  position: relative;
}

.airplane_blue:hover,
.airplane_green:hover,
.airplane_red:hover,
.airplane_darkgreen:hover,
.airplane_brown:hover {
  fill: var(--full-orange);
  paint-order: stroke;
}

.airplane_brown {
  fill: var(--full-brown);
  stroke: var(--full-black);
  paint-order: stroke;
}

.airplane_green {
  fill: var(--full-green);
  stroke: var(--full-black);
  paint-order: stroke;
}

.airplane_blue {
  fill: var(--blue-highlight);
  stroke: var(--full-black);
  paint-order: stroke;
}

.airplane_orange {
  fill: var(--full-orange);
  stroke: var(--full-black);
  paint-order: stroke;
}

.airplane_red {
  fill: var(--full-red);
  stroke: var(--full-black);
  paint-order: stroke;
}

.airplane_darkgreen {
  fill: var(--full-darkgreen);
  stroke: var(--full-black);
  paint-order: stroke;
}

svg {
  position: relative;
  display: block;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;
}

div#stat_images {
  max-width: 1000px;
}

div#planes {
  width: 340px;
  max-height: calc(100vh - 160px);
  overflow: scroll;
  position: relative;
  float: right;
  display: flex;
  flex-direction: column;
  left: 5px !important;
}

div.plane_list_no_hover,
div.plane_list {
  display: inline-block;
  width: 100%;
  border-top: 1px solid var(--full-black);
  border-bottom: 1px solid var(--full-black);
  color: var(--full-white);
  background-color: var(--blue-highlight);
  font-weight: bold;
}

div.plane_list:hover {
  background-color: var(--datablock-bg);
  color: var(--blue-highlight);
}

div.plane_element {
  display: inline-block;
  position: relative;
  padding-left: 5px;
  border-left: 2px solid var(--full-black);
}

.plane_header a {
  color: var(--blue-highlight) !important;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;
}

.noleft {
  border-left: 0 solid var(--transparent) !important;
}

.sidebar_hovered_from_map_acars {
  background-color: var(--datablock-bg) !important;
  color: var(--full-green) !important;
}

.sidebar_hovered_from_map_no_acars {
  background-color: var(--datablock-bg) !important;
  color: var(--blue-highlight) !important;
}

.sidebar_no_hover_with_acars {
  background-color: var(--full-green) !important;
  color: var(--full-white) !important;
  font-weight: bold !important;
}

.sidebar_no_hover_with_unread {
  background-color: var(--full-darkgreen) !important;
  color: var(--full-white) !important;
  font-weight: bold !important;
}

.sidebar_no_hover_with_unread:hover,
.sidebar_no_hover_with_unread:focus,
.sidebar_no_hover_with_unread:hover a,
.sidebar_no_hover_with_unread:focus a,
.sidebar_hovered_from_map_with_unread,
.sidebar_hovered_from_map_with_unread a {
  background-color: var(--datablock-bg) !important;
  color: var(--full-darkgreen) !important;
  font-weight: bold !important;
}

.sidebar_no_hover_with_acars:hover,
.sidebar_no_hover_with_acars:focus,
.sidebar_no_hover_with_acars:hover a,
.sidebar_no_hover_with_acars:focus a {
  background-color: var(--datablock-bg) !important;
  color: var(--full-green) !important;
}

.sidebar_alert_unread_hovered_from_map,
.sidebar_alert_unread_hovered_from_map a,
.sidebar_alert_unread:hover,
.sidebar_alert_unread:focus,
.sidebar_alert_unread:hover a,
.sidebar_alert_unread:focus a {
  background-color: var(--datablock-bg) !important;
  color: var(--full-red) !important;
}

.sidebar_alert_read_hovered_from_map,
.sidebar_alert_read_hovered_from_map a,
.sidebar_alert_read:hover,
.sidebar_alert_read:focus,
.sidebar_alert_read:hover a,
.sidebar_alert_read:focus a {
  background-color: var(--datablock-bg) !important;
  color: var(--full-brown) !important;
}

.sidebar_hovered_from_map_acars .plane_element a {
  color: var(--full-green) !important;
}

.sidebar_alert_unread {
  background-color: var(--full-red) !important;
}

.sidebar_alert_read {
  background-color: var(--full-brown) !important;
}

.plane_element a {
  color: var(--full-white);
}

.airplane_datablock {
  background: var(--datablock-bg);
  color: var(--full-black);
  font-weight: bold;
  text-transform: uppercase;
  max-width: 120px;
  max-height: 120px;
  width: max-content;
  padding: 4px;
  border-radius: 15px;
  border: 2px solid var(--datablock-border);
  -moz-border-radius: 15px;
  font-family: var(--mono-fonts);
}
`, "",{"version":3,"sources":["webpack://./src/css/site.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,+DAA+D;EAC/D,oCAAoC;EACpC,0BAA0B;EAC1B,0BAA0B;EAC1B,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,qCAAqC;EACrC,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,wCAAwC;EACxC,iCAAiC;EACjC,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,0CAA0C;EAC1C,wCAAwC;EACxC,iCAAiC;EACjC,4BAA4B;EAC5B,mCAAmC;EACnC,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmCE;;AAEF;EACE,mCAAmC;EACnC,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;EACzC,uCAAuC;EACvC,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,uBAAuB;EACvB,wBAAwB,EAAE,gCAAgC;EAC1D,qBAAqB,EAAE,gBAAgB;EACvC,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,kCAAkC;AACnD;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;IACxB,8BAA8B;EAChC;AACF;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,qBAAqB,EAAE,kBAAkB;EACzC,0BAA0B,EAAE,wBAAwB;EACpD,sBAAsB,EAAE,cAAc;EACtC,wBAAwB,EAAE,YAAY;EACtC,qBAAqB,EAAE,2BAA2B;EAClD,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;IACxB,qBAAqB;EACvB;AACF;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8CAA8C;EAC9C,2CAA2C;EAC3C,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,qCAAqC;EACrC;;;;GAIC;EACD;;;;GAIC;EACD;;;;GAIC;EACD;;;;GAIC;EACD,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,+BAA+B;EAC/B,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA,UAAU;AACV;;EAEE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,uCAAuC;IACvC,6BAA6B;EAC/B;EACA;;IAEE,wBAAwB;IACxB,6BAA6B;EAC/B;AACF;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;EAC3C,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,aAAa;;AAEb;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iCAAiC;EACjC,oCAAoC;EACpC,mCAAmC;EACnC,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;;AAEjB;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,wCAAwC;EACxC,uCAAuC;EACvC,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,wCAAwC;EACxC,uCAAuC;EACvC,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;;;;;;GAMG;;AAEH;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,uBAAuB;;AAEvB;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,+CAA+C;EAC/C,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,gCAAgC;EAChC,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,iCAAiC;EACjC,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,SAAS;IACT,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,sCAAsC;IACtC,0CAA0C;EAC5C;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;;;;IAKE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;KAEG;;EAEH;IACE,0CAA0C;EAC5C;;EAEA;IACE,sCAAsC;IACtC,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,WAAW;EACX,sCAAsC;EACtC,WAAW;EACX,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;EAKE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,uCAAuC;EACvC,0CAA0C;EAC1C,wBAAwB;EACxB,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,gDAAgD;EAChD,mCAAmC;AACrC;;AAEA;EACE,gDAAgD;EAChD,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;EAC9C,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,kDAAkD;EAClD,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;;;;;;EAME,gDAAgD;EAChD,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;;;;EAIE,gDAAgD;EAChD,mCAAmC;AACrC;;AAEA;;;;;;EAME,gDAAgD;EAChD,iCAAiC;AACnC;;AAEA;;;;;;EAME,gDAAgD;EAChD,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,wBAAwB;EACxB,8BAA8B;AAChC","sourcesContent":[":root {\n  --site-fonts: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  --mono-fonts: Menlo, Monaco, Consolas, \"Courier New\", monospace;\n  --blue-highlight: hsl(193, 81%, 41%);\n  --body-bg: hsl(0, 0%, 96%);\n  --grey-bg: hsl(0, 0%, 24%);\n  --grey-highlight: hsl(0, 0%, 75%);\n  --full-black: hsl(0, 0%, 0%);\n  --full-red: hsl(0, 100%, 50%);\n  --full-brown: hsl(0, 51%, 33%);\n  --full-orange: hsl(39, 100%, 50%);\n  --full-yellow: hsl(60, 100%, 50%);\n  --full-green: hsl(120, 100%, 25%);\n  --full-darkgreen: hsl(120, 100%, 13%);\n  --full-limegreen: hsl(120, 61%, 50%);\n  --full-white: hsl(250, 100%, 100%);\n  --datablock-bg: hsla(0, 0%, 100%, 0.2);\n  --datablock-border: hsla(0, 0%, 0%, 0.3);\n  --transparent: hsla(0, 0%, 0%, 0);\n  --light-wight: hsl(0, 0%, 93%);\n  --creamy-white: hsl(0, 0%, 80%);\n  --pale-white: hsl(0, 0%, 73%);\n  --mostly-transparent: hsla(0, 0%, 0%, 0.2);\n  --decor-banner-green: hsl(149, 29%, 56%);\n  --nav-text-shadow: hsl(0, 0%, 5%);\n  --egg-white: hsl(0, 0%, 80%);\n  --tabs-grey-shadow: hsl(0, 0%, 58%);\n  --jbox-shadow: hsla(0, 0%, 0%, 0.25);\n  --mapbackground: hsl(0, 0%, 60%);\n}\n\n/*div * {\n  scrollbar-width: none; /* Firefox\n  -ms-overflow-style: none; /* IE 10+\n}\ndiv *::-webkit-scrollbar-track {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  background-color: transparent;\n}\ndiv *::-webkit-scrollbar {\n  width: 3px !important;\n  background-color: transparent;\n}\ndiv *::-webkit-scrollbar-thumb {\n  background-color: transparent;\n}\n\n.on-scrollbar{\n  scrollbar-width: thin; /* Firefox\n  -ms-overflow-style: none; /* IE 10+\n}\n\n.on-scrollbar::-webkit-scrollbar-track {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  background-color: transparent !important;\n}\n\n.on-scrollbar::-webkit-scrollbar {\n  width: 6px !important;\n  background-color: transparent;\n}\n\n.on-scrollbar::-webkit-scrollbar-thumb {\n  background-color: #acacac;\n}*/\n\ntable {\n  border: 1px solid var(--full-black);\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  background-color: var(--full-white);\n}\n\nthead {\n  border: 1px solid var(--full-black);\n}\n\nth {\n  padding-left: 5px;\n}\n\n#main_block h3 {\n  margin-top: 0;\n}\n\ntable.search {\n  border: 1px solid var(--full-black);\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  background-color: transparent;\n  vertical-align: middle;\n}\n\ntable.message {\n  border: none;\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  background-color: var(--full-white);\n  vertical-align: top;\n}\n\n.text_top {\n  vertical-align: top;\n}\n\n.align_right {\n  float: right;\n}\n\ntextarea {\n  width: 95%;\n}\n\nimg {\n  max-width: 100%;\n}\n\n.boxed {\n  background-color: var(--full-white);\n  box-sizing: border-box;\n  display: inline-block;\n  padding-top: 8px;\n  padding-bottom: 6px;\n  padding-right: 10px;\n  padding-left: 10px;\n  width: 45px;\n  text-align: center;\n  color: var(--full-black);\n  margin-bottom: -1px;\n  border-left: 1px solid var(--full-black);\n  border-right: 1px solid var(--full-black);\n  border-top: 1px solid var(--full-black);\n  border-bottom: 1px solid var(--full-black);\n  font-weight: bold;\n}\n\n.boxed_right_arrow {\n  margin-left: -1px;\n}\n\n.small_img {\n  height: 14px;\n  vertical-align: middle;\n  padding-bottom: 3px;\n}\n\n.monofont {\n  font-family: var(--mono-fonts);\n}\n\n.red,\n.red_body {\n  color: var(--full-red);\n}\n\nspan.red_important strong {\n  color: var(--full-red) !important;\n}\n\n.orange {\n  color: var(--full-orange);\n}\n\n.green {\n  color: var(--full-limegreen);\n}\n\n@media not all and (pointer: coarse) {\n  .red:hover {\n    color: var(--full-white);\n  }\n}\n\n.footer strong {\n  color: var(--blue-highlight);\n}\n\n.sidebar_link {\n  color: var(--blue-highlight);\n}\n\n@media not all and (pointer: coarse) {\n  .sidebar_link:hover {\n    color: var(--full-white);\n  }\n}\n\nol {\n  list-style-type: circle;\n  margin-left: 0;\n  padding-left: 1em;\n  margin-left: 1em;\n}\n\nol > li {\n  width: 100%;\n  margin-left: 0;\n  padding-left: 0;\n}\n\ntd {\n  padding: 7px;\n}\n\nhr {\n  display: block;\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n  margin-left: auto;\n  margin-right: auto;\n  border-style: inset;\n  border-top: 0.1em solid var(--grey-bg);\n  color: var(--body-bg);\n}\n\nbody {\n  height: 100vh;\n  width: 100vw;\n  background-color: var(--body-bg);\n  padding-left: 20px;\n  padding-right: 20px;\n  min-width: 400px;\n  margin-left: auto;\n  margin-right: auto;\n  font-family: var(--site-fonts);\n  font-size: 14px;\n  line-height: 1.42857143;\n  -ms-overflow-style: none; /* for Internet Explorer, Edge */\n  scrollbar-width: none; /* for Firefox */\n  overflow-y: scroll;\n}\n\nbody::-webkit-scrollbar {\n  display: none; /* for Chrome, Safari, and Opera */\n}\n\n.container {\n  margin: 30px auto;\n  width: 100%;\n  position: relative;\n  width: 100%;\n  margin-top: 0;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\ndiv#content.container {\n  position: fixed;\n  top: 105px;\n  padding-left: 20px;\n  padding-right: 20px;\n  width: calc(100vw - 40px);\n  margin-bottom: 40px;\n  overflow: scroll;\n  height: calc(100vh - 125px);\n}\n\ndiv#main_block.row {\n  margin-left: 0;\n  padding-top: 5px;\n}\n\ndiv#header {\n  margin: 0;\n  width: calc(100vw - 40px);\n  position: fixed;\n}\n\ndiv#links.row {\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  top: 0;\n}\n\ndiv#num_results.row {\n  position: relative;\n  width: 100%;\n  height: inherit;\n  padding-top: 10px;\n  margin-right: 0;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n\ntable.search thead {\n  border: 0;\n}\n\ndiv#log.left {\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.acarshub-message-group {\n  margin: auto;\n}\n\n#size {\n  color: var(--blue-highlight);\n}\n\n#database {\n  color: var(--blue-highlight);\n}\n\n#log {\n  margin-right: 5px;\n}\n\n.search_label {\n  width: 30%;\n  vertical-align: middle;\n  color: var(--blue-highlight);\n}\n\n.search_term {\n  width: 70%;\n  padding-left: 15px;\n  padding-right: 20px;\n}\n\n.fixed_results {\n  position: fixed;\n  top: 60px;\n  bottom: 30px;\n  padding-top: 0;\n  margin-bottom: 10px;\n  width: 280px;\n  margin-right: 5px;\n  margin-left: 10px;\n  padding-right: 5px;\n  padding-top: 10px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.fixed_menu {\n  position: fixed;\n  top: 170px;\n  bottom: 30px;\n  padding-top: 0;\n  margin-bottom: 10px;\n  width: 280px;\n  margin-top: 0;\n  margin-right: 5px;\n  margin-left: 10px;\n  margin-bottom: 30px;\n  padding-right: 5px;\n  padding-top: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.fixed_menu_short {\n  position: fixed;\n  top: 150px;\n  bottom: 30px;\n  padding-top: 0;\n  margin-bottom: 10px;\n  width: 280px;\n  margin-top: 0;\n  margin-right: 5px;\n  margin-left: 10px;\n  margin-bottom: 30px;\n  padding-right: 5px;\n  padding-top: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.spread_text {\n  letter-spacing: 1px;\n  padding-left: 4px;\n}\n\n@media not all and (pointer: coarse) {\n  a.spread_text:hover {\n    color: var(--full-black);\n  }\n}\n\n.red {\n  color: var(--full-red);\n}\n\n.white {\n  color: var(--full-white);\n}\nselect {\n  min-width: 100%;\n}\n\ninput {\n  min-width: 100%;\n  width: 30px;\n  color: var(--full-black);\n}\n\nlabel {\n  padding-top: 5px;\n}\n\n.menu_non_link {\n  color: var(--blue-highlight);\n  text-transform: uppercase;\n}\n\n.footer {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: var(--grey-bg);\n  text-align: left;\n  border: 1px solid var(--full-black);\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n  z-index: 20;\n  font-weight: bold;\n}\n\n@media not all and (pointer: coarse) {\n  .footer a:hover {\n    color: var(--full-white);\n    transition: all 0.25s ease-out;\n  }\n}\n\n.footer div {\n  display: inline-block;\n  border-right: 1px solid var(--grey-highlight);\n  padding-right: 5px;\n}\n\n.shadow {\n  box-shadow: 2px 2px 2px 1px var(--mostly-transparent);\n}\n\npre {\n  box-shadow: 2px 2px 2px 1px var(--mostly-transparent);\n  white-space: pre-wrap; /* Since CSS 2.1 */\n  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */\n  white-space: -pre-wrap; /* Opera 4-6 */\n  white-space: -o-pre-wrap; /* Opera 7 */\n  word-wrap: break-word; /* Internet Explorer 5.5+ */\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\na {\n  color: var(--blue-highlight);\n  text-decoration: none;\n  text-transform: uppercase;\n  text-decoration: none;\n}\n\n@media not all and (pointer: coarse) {\n  a:hover {\n    color: var(--full-black);\n    text-decoration: none;\n  }\n}\n\na:active {\n  color: var(--blue-highlight);\n  text-decoration: none;\n}\n\na:visited {\n  color: var(--blue-highlight);\n  text-decoration: none;\n}\n\n.wrap {\n  display: block;\n  position: relative;\n  -webkit-box-shadow: 0 0 70px var(--full-white);\n  -moz-box-shadow: 0 0 70px var(--full-white);\n  box-shadow: 0 0 70px var(--full-white);\n  margin-left: auto;\n  margin-right: auto;\n  top: 0;\n}\n\n.decor {\n  background: var(--decor-banner-green);\n  background: -webkit-linear-gradient(\n    left,\n    var(--grey-bg) 50%,\n    var(--blue-highlight) 50%\n  );\n  background: -moz-linear-gradient(\n    left,\n    var(--grey-bg) 50%,\n    var(--blue-highlight) 50%\n  );\n  background: -o-linear-gradient(\n    left,\n    var(--grey-bg) 50%,\n    var(--blue-highlight) 50%\n  );\n  background: linear-gradient(\n    to left,\n    var(--grey-bg) 50%,\n    var(--blue-highlight) 50%\n  );\n  background-size: 50px 25%;\n  padding: 2px;\n  display: block;\n  z-index: 200;\n}\n\nul {\n  list-style: none;\n  position: relative;\n  text-align: left;\n  padding-left: 10px;\n}\n\n.right_side {\n  float: right;\n  z-index: 300;\n}\n\nli {\n  float: left;\n}\n\n/* clear'n floats */\nul::after {\n  clear: both;\n}\n\nul::before,\nul::after {\n  content: \" \";\n  display: table;\n}\n\nnav {\n  position: relative;\n  background: var(--grey-bg);\n  text-align: center;\n  letter-spacing: 3px;\n  text-shadow: 1px 1px 1px var(--nav-text-shadow);\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n  z-index: 10;\n  padding-bottom: 1px;\n}\n\n.nav_text {\n  display: block;\n  padding-top: 23px;\n  padding-bottom: 10px;\n  padding-right: 20px;\n  padding-left: 20px;\n  color: var(--blue-highlight);\n  text-transform: uppercase;\n}\n\nul.primary li a.invert_a,\nul.primary li a.invert_a:visited {\n  color: var(--full-white) !important;\n}\n\n/* prime */\nul.primary li a,\nul.primary li a:visited {\n  display: block;\n  padding-top: 35px;\n  padding-bottom: 10px;\n  padding-right: 20px;\n  padding-left: 20px;\n}\n\nul.primary li:last-child a {\n  border-right: none;\n}\n\n@media not all and (pointer: coarse) {\n  ul.primary li a.invert_a:hover {\n    color: var(--blue-highlight) !important;\n    transition: all 0.25s ease-in;\n  }\n  ul.primary li a:hover,\n  ul.primary li a:active {\n    color: var(--full-white);\n    transition: all 0.25s ease-in;\n  }\n}\n\n/* subs */\nul.sub {\n  position: absolute;\n  z-index: 200;\n  box-shadow: 2px 2px 0 var(--grey-highlight);\n  width: 35%;\n  display: none;\n}\n\nul.sub li {\n  float: none;\n  margin: 0;\n}\n\nul.sub li a {\n  border-bottom: 1px dotted var(--creamy-white);\n  border-right: none;\n  color: var(--full-black);\n  padding: 15px 0;\n}\n\nul.sub li:last-child a {\n  border-bottom: none;\n}\n\nul.sub li a:hover {\n  color: var(--full-white);\n  background: var(--light-white);\n}\n\n/* sub display */\nul.primary li:hover ul {\n  display: block;\n}\n\n/* keeps the tab background white */\nul.primary li:hover a {\n  color: var(--full-white);\n  text-shadow: none;\n}\n\nul.primary li:hover > a {\n  color: var(--full-white);\n}\n\n/* Collapse */\n\ninput[type=\"checkbox\"] {\n  display: none;\n}\n\n.wrap-collabsible {\n  padding-top: 0;\n}\n\n.lbl-toggle {\n  display: block;\n  text-transform: uppercase;\n  text-align: left;\n  color: var(--blue-highlight);\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.25s ease-out;\n  font-weight: normal;\n  padding-top: 10px;\n}\n\n.lbl-toggle:hover {\n  color: var(--full-white);\n}\n\n.lbl-toggle::before {\n  content: \" \";\n  display: inline-block;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid currentColor;\n  vertical-align: middle;\n  margin-right: 0.7rem;\n  transform: translateY(-2px);\n  transition: transform 0.2s ease-out;\n}\n\n.toggle::checked + .lbl-toggle::before {\n  transform: rotate(90deg) translateX(-3px);\n}\n\n.collapsible-content {\n  max-height: 0;\n  overflow: scroll;\n  height: calc(100% - 250px);\n  transition: max-height 0.25s ease-in-out;\n}\n\n.toggle:checked + .lbl-toggle + .collapsible-content {\n  max-height: 100%;\n}\n\n.toggle::checked + .lbl-toggle {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.collapsible-content .content-inner {\n  background: transparent;\n  color: var(--blue-highlight);\n  padding-right: 10px;\n  padding-left: 10px;\n  overflow: scroll;\n}\n\n.collapsible-content p {\n  margin-bottom: 30px;\n}\n\n/* message tabs */\n\n.tabinator {\n  background: transparent;\n}\n\n.tabinator input {\n  display: none;\n}\n\n.tabinator label {\n  background-color: var(--full-white);\n  box-sizing: border-box;\n  display: inline-block;\n  padding-top: 8px;\n  padding-bottom: 6px;\n  padding-right: 10px;\n  padding-left: 10px;\n  width: 90px;\n  text-align: center;\n  color: var(--full-black);\n  margin-top: 0px;\n  margin-bottom: -1px;\n  margin-left: -1px;\n  font-weight: bold;\n  border-left: 1px solid var(--full-black);\n  border-top: 1px solid var(--full-black);\n  border-right: 1px solid var(--full-black);\n  border-bottom: 1px solid var(--full-black);\n}\n\n.tabinator label::before {\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 15px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n}\n\n.tabinator label:hover {\n  color: var(--grey-bg);\n  cursor: pointer;\n}\n\n.tabinator input:checked + label {\n  position: relative;\n  color: var(--full-white);\n  background: var(--full-black);\n  border-left: 1px solid var(--full-black);\n  border-top: 1px solid var(--full-black);\n  border-right: 1px solid var(--full-black);\n  font-weight: bold;\n  font-style: normal;\n}\n\n.tabinator input::checked + label::after {\n  display: block;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  box-shadow: 0 0 15px var(--tabs-grey-shadow);\n}\n\n[id^=\"message\"] {\n  display: none;\n  border-top: 1px solid var(--grey-highlight);\n}\n\n.checked {\n  display: block;\n  box-shadow: 0 0 15px var(--grey-highlight);\n}\n\n.circle_red {\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  border: 1px solid;\n  background-color: var(--full-red);\n  display: inline-block;\n}\n\n.circle_orange {\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  border: 1px solid;\n  background-color: var(--full-orange);\n  display: inline-block;\n}\n\n.circle_yellow {\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  border: 1px solid;\n  background-color: var(--full-yellow);\n  display: inline-block;\n}\n\n.circle_green {\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  border: 1px solid;\n  background-color: var(--full-green);\n  display: inline-block;\n}\n\nimg.banner_img {\n  max-width: 70px;\n  max-height: 70px;\n}\n\nli.img_box {\n  width: 100px;\n  height: 82px;\n  display: block;\n  padding-top: 5px;\n  padding-bottom: 0;\n  border-right: 1px solid var(--grey-bg);\n  text-align: center;\n  color: var(--grey-bg);\n  text-shadow: none;\n}\n\nli.img_box svg {\n  max-width: 85%;\n  max-height: 80px;\n  letter-spacing: 0;\n}\n\n/* canvas {\n  width: 100% !important;\n  height: 100% !important;\n} */\n\n/* .canvas_wrapper {\n  position: relative;\n  width: 100%;\n  max-width: 1000px !important;\n  display: flex;\n  /* float: left;\n} */\n\n.chart-container {\n  position: relative;\n  /* min-height: auto; */\n  width: 100%;\n  max-width: 1000px !important;\n  height: 300px;\n  /* overflow: hidden; */\n}\n\n#chart_msg_good,\n#chart_msg_empty {\n  height: 150px !important;\n}\n\n/* modal window stuff */\n\n#set_modal.jBox-wrapper .jBox-title {\n  background-color: var(--egg-white);\n  color: var(--blue-highlight);\n  font-family: var(--site-fonts);\n  font-size: 20px;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n#set_modal.jBox-wrapper .jBox-content {\n  background-color: var(--grey-bg);\n  font-family: var(--site-fonts);\n}\n\n#airplane .jBox-content {\n  font-family: var(--mono-fonts) !important;\n  text-transform: uppercase;\n}\n\n#airplane.jBox-Tooltip.jBox-wrapper .jBox-content {\n  border-radius: 0 0 15px 15px;\n  -moz-border-radius: 0 0 15px 15px;\n}\n\n.jBox-wrapper {\n  border-radius: 15px;\n  border: 2px solid var(--datablock-border);\n  padding: 5px;\n  border-radius: 15px;\n  -moz-border-radius: 15px;\n  background-color: var(--grey-bg);\n  box-shadow: 0 0 3px var(--jbox-shadow);\n}\n\n.jBox-Modal {\n  max-height: 80%;\n}\n\n.jBox-wrapper.jBox-Tooltip,\n.jBox-wrapper.jBox-Mouse {\n  max-width: 250px;\n}\n\n.jBox-container {\n  background-color: var(--grey-bg);\n  border-radius: 0;\n  box-shadow: 0 0 0 var(--transparent) !important;\n  width: inherit;\n  height: inherit;\n}\n\n.jBox-Mouse.jBox-wrapper .jBox-content,\n.jBox-Tooltip.jBox-wrapper .jBox-content {\n  background-color: var(--grey-bg);\n  color: var(--blue-highlight);\n  font-size: 12px;\n  font-weight: bold;\n  font-family: var(--site-fonts);\n  box-shadow: none;\n}\n\n.jBox-wrapper .jBox-title {\n  background-color: var(--egg-white);\n  color: var(--blue-highlight);\n  font-family: var(--site-fonts);\n  font-size: 15px;\n  text-transform: uppercase;\n  text-align: center;\n  border-radius: 15px 15px 0 0;\n  -moz-border-radius: 15px 15px 0 0;\n  text-transform: uppercase;\n  padding: 0;\n  width: 100%;\n}\n\na[x-apple-data-detectors] {\n  color: inherit !important;\n  text-decoration: none !important;\n  font-size: inherit !important;\n  font-family: inherit !important;\n  font-weight: inherit !important;\n  line-height: inherit !important;\n}\n\n@media only screen and (min-width: 0px) {\n  .container {\n    min-width: 400px;\n    max-width: calc(100vw - 40px);\n  }\n}\n\n@media screen and (max-width: 1070px) {\n  #release_version {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 1150px) {\n  #discord_badge {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 1200px) {\n  div#content.container {\n    top: 77px;\n    height: calc(100vh - 98px);\n  }\n\n  #logo_image {\n    display: none;\n  }\n\n  ul.primary li a {\n    padding-top: 23px;\n  }\n\n  nav {\n    letter-spacing: 1px;\n  }\n\n  .right_side {\n    float: left;\n  }\n\n  #planes {\n    max-height: calc(100vh - 130px) !important;\n  }\n\n  #mapid {\n    height: calc(100vh - 130px) !important;\n    max-height: calc(100vh - 130px) !important;\n  }\n\n  #update_notice {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 970px) {\n  #search_results {\n    width: calc(100vw - 295px) !important;\n  }\n\n  #side_pane {\n    width: 200px !important;\n  }\n\n  div#content.container {\n    top: 140px;\n    height: calc(100vh - 160px);\n  }\n\n  .decor {\n    padding: 3px;\n  }\n\n  .wrap {\n    width: 100%;\n    margin-top: 0;\n    font-size: 10px;\n  }\n\n  li {\n    float: none;\n  }\n\n  ul.primary li a {\n    padding-top: 2.5px;\n    padding-bottom: 2.5px;\n    padding-right: 2.5px;\n    padding-left: 2.5px;\n  }\n\n  ul.sub li a:hover {\n    color: var(--egg-white);\n    background: none;\n  }\n\n  #discord_badge,\n  #github_link,\n  #release_version,\n  .dont_show,\n  .show_when_big {\n    display: none;\n  }\n\n  #msg_body {\n    column-span: all;\n  }\n\n  /* .show_when_small {\n    display: inline-block;\n  } */\n\n  #planes {\n    max-height: calc(100vh - 170px) !important;\n  }\n\n  #mapid {\n    height: calc(100vh - 170px) !important;\n    max-height: calc(100vh - 170px) !important;\n  }\n}\n\n@media only screen and (min-width: 970px) {\n  .show_when_small {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 700px) {\n  #mapid {\n    width: 100%;\n    max-width: 100% !important;\n  }\n\n  #planes {\n    display: none !important;\n  }\n\n  div#content.container {\n    top: 140px;\n    height: calc(100vh - 160px);\n  }\n\n  #search_results {\n    width: 100% !important;\n  }\n\n  #side_pane {\n    width: 100% !important;\n  }\n\n  #acarshub_help {\n    display: none;\n  }\n}\n\n#msg_body {\n  column-span: inherit;\n}\n\n.show_strong {\n  font-weight: bold;\n  font-family: var(--mono-fonts);\n}\n\n#search_results {\n  width: calc(100vw - 440px);\n  max-height: 100%;\n  margin-left: 5px;\n  overflow: auto;\n  float: left;\n}\n\n#side_pane {\n  width: 340px;\n  max-height: 100%;\n  overflow: auto;\n  float: left;\n}\n\n#mapid {\n  height: calc(100vh - 160px);\n  max-height: calc(100vh - 160px);\n  width: 100%;\n  background-color: var(--mapbackground);\n  float: left;\n  max-width: calc(100vw - 435px);\n  flex: 1 1 auto;\n  position: relative;\n}\n\n.airplane_blue:hover,\n.airplane_green:hover,\n.airplane_red:hover,\n.airplane_darkgreen:hover,\n.airplane_brown:hover {\n  fill: var(--full-orange);\n  paint-order: stroke;\n}\n\n.airplane_brown {\n  fill: var(--full-brown);\n  stroke: var(--full-black);\n  paint-order: stroke;\n}\n\n.airplane_green {\n  fill: var(--full-green);\n  stroke: var(--full-black);\n  paint-order: stroke;\n}\n\n.airplane_blue {\n  fill: var(--blue-highlight);\n  stroke: var(--full-black);\n  paint-order: stroke;\n}\n\n.airplane_orange {\n  fill: var(--full-orange);\n  stroke: var(--full-black);\n  paint-order: stroke;\n}\n\n.airplane_red {\n  fill: var(--full-red);\n  stroke: var(--full-black);\n  paint-order: stroke;\n}\n\n.airplane_darkgreen {\n  fill: var(--full-darkgreen);\n  stroke: var(--full-black);\n  paint-order: stroke;\n}\n\nsvg {\n  position: relative;\n  display: block;\n  margin-top: auto;\n  margin-bottom: auto;\n  margin-left: auto;\n  margin-right: auto;\n}\n\ndiv#stat_images {\n  max-width: 1000px;\n}\n\ndiv#planes {\n  width: 340px;\n  max-height: calc(100vh - 160px);\n  overflow: scroll;\n  position: relative;\n  float: right;\n  display: flex;\n  flex-direction: column;\n  left: 5px !important;\n}\n\ndiv.plane_list_no_hover,\ndiv.plane_list {\n  display: inline-block;\n  width: 100%;\n  border-top: 1px solid var(--full-black);\n  border-bottom: 1px solid var(--full-black);\n  color: var(--full-white);\n  background-color: var(--blue-highlight);\n  font-weight: bold;\n}\n\ndiv.plane_list:hover {\n  background-color: var(--datablock-bg);\n  color: var(--blue-highlight);\n}\n\ndiv.plane_element {\n  display: inline-block;\n  position: relative;\n  padding-left: 5px;\n  border-left: 2px solid var(--full-black);\n}\n\n.plane_header a {\n  color: var(--blue-highlight) !important;\n  text-decoration: none;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n\n.noleft {\n  border-left: 0 solid var(--transparent) !important;\n}\n\n.sidebar_hovered_from_map_acars {\n  background-color: var(--datablock-bg) !important;\n  color: var(--full-green) !important;\n}\n\n.sidebar_hovered_from_map_no_acars {\n  background-color: var(--datablock-bg) !important;\n  color: var(--blue-highlight) !important;\n}\n\n.sidebar_no_hover_with_acars {\n  background-color: var(--full-green) !important;\n  color: var(--full-white) !important;\n  font-weight: bold !important;\n}\n\n.sidebar_no_hover_with_unread {\n  background-color: var(--full-darkgreen) !important;\n  color: var(--full-white) !important;\n  font-weight: bold !important;\n}\n\n.sidebar_no_hover_with_unread:hover,\n.sidebar_no_hover_with_unread:focus,\n.sidebar_no_hover_with_unread:hover a,\n.sidebar_no_hover_with_unread:focus a,\n.sidebar_hovered_from_map_with_unread,\n.sidebar_hovered_from_map_with_unread a {\n  background-color: var(--datablock-bg) !important;\n  color: var(--full-darkgreen) !important;\n  font-weight: bold !important;\n}\n\n.sidebar_no_hover_with_acars:hover,\n.sidebar_no_hover_with_acars:focus,\n.sidebar_no_hover_with_acars:hover a,\n.sidebar_no_hover_with_acars:focus a {\n  background-color: var(--datablock-bg) !important;\n  color: var(--full-green) !important;\n}\n\n.sidebar_alert_unread_hovered_from_map,\n.sidebar_alert_unread_hovered_from_map a,\n.sidebar_alert_unread:hover,\n.sidebar_alert_unread:focus,\n.sidebar_alert_unread:hover a,\n.sidebar_alert_unread:focus a {\n  background-color: var(--datablock-bg) !important;\n  color: var(--full-red) !important;\n}\n\n.sidebar_alert_read_hovered_from_map,\n.sidebar_alert_read_hovered_from_map a,\n.sidebar_alert_read:hover,\n.sidebar_alert_read:focus,\n.sidebar_alert_read:hover a,\n.sidebar_alert_read:focus a {\n  background-color: var(--datablock-bg) !important;\n  color: var(--full-brown) !important;\n}\n\n.sidebar_hovered_from_map_acars .plane_element a {\n  color: var(--full-green) !important;\n}\n\n.sidebar_alert_unread {\n  background-color: var(--full-red) !important;\n}\n\n.sidebar_alert_read {\n  background-color: var(--full-brown) !important;\n}\n\n.plane_element a {\n  color: var(--full-white);\n}\n\n.airplane_datablock {\n  background: var(--datablock-bg);\n  color: var(--full-black);\n  font-weight: bold;\n  text-transform: uppercase;\n  max-width: 120px;\n  max-height: 120px;\n  width: max-content;\n  padding: 4px;\n  border-radius: 15px;\n  border: 2px solid var(--datablock-border);\n  -moz-border-radius: 15px;\n  font-family: var(--mono-fonts);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
